import { Modal, ModalBody, ModalContent, ModalHeader } from '@heroui/react';
import React from 'react';
import { useIsMobile } from '@/app/hooks/use-is-mobile';

type ModalTemplateProps = {
  onOpenChange: (value: boolean) => void;
  isOpen: boolean;
  title?: string;
  children: React.ReactNode;
  isDismissable?: boolean;
};
export default function ModalTemplate({
  onOpenChange,
  isOpen,
  title,
  children,
  isDismissable,
}: ModalTemplateProps) {
  const isMobile = useIsMobile();

  return (
    <Modal
      isOpen={isOpen}
      isDismissable={isDismissable}
      size={isMobile ? 'sm' : '3xl'}
      onOpenChange={onOpenChange}
      scrollBehavior="outside"
      placement="center"
      classNames={{
        backdrop: 'bg-[var(--color-text-subtle)/50]',
        base: 'md:px-[126px] py-16 bg-[var(--color-card-primary)] rounded-xl text-base md:text-lg',
        closeButton:
          'custom-close-button hover:bg-[var(--color-card-primary)]/5 active:bg-[var(--color-card-primary)]/10',
      }}
    >
      <ModalContent>
        {title && (
          <ModalHeader className="font-heading text-[28px] md:text-4xl leading-[46px]">
            {title}
          </ModalHeader>
        )}
        <ModalBody>{children}</ModalBody>
      </ModalContent>
    </Modal>
  );
}
